import { useExamEventDetails } from '@exam-center/exam-event-management';
import { ExamGradingStatus } from '@exam-center/graphql';
import { Alert, type AlertProps, Box, Text } from '@shared/components';

const ALERT_MAPPING: Record<string, { severity: AlertProps['severity']; message: string }> = {
  FAILED: {
    severity: 'error',
    message: 'ตรวจข้อสอบไม่สำเร็จ กรุณาตรวจสอบไฟล์และอัปโหลดใหม่อีกครั้ง',
  },
  IN_PROGRESS: {
    severity: 'warning',
    message: 'ระบบกำลังดำเนินการตรวจข้อสอบ โปรดรอจนกว่าการตรวจจะเสร็จสิ้น',
  },
};

export default function ExamEventExamineeResultBanner() {
  const {
    examEvent: {
      metadata: { examGradingStatus },
    },
  } = useExamEventDetails();

  if (!examGradingStatus || examGradingStatus === ExamGradingStatus.Completed) {
    return null;
  }

  return (
    <Box sx={(theme) => ({ p: theme.spacing(6, 6, 0, 6) })}>
      <Alert severity={ALERT_MAPPING[examGradingStatus].severity}>
        <Text>{ALERT_MAPPING[examGradingStatus].message}</Text>
      </Alert>
    </Box>
  );
}
